import React from "react";
import {
  LockClosedIcon,
  BanIcon,
  CurrencyDollarIcon,
} from "@heroicons/react/outline";
import { motion } from "framer-motion";

function Tokenomics() {
  return (
    <div id="tokoonomics" className="tokenomics section">
      <svg
        className="tokenomics_wave"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
      >
        <path
          fill="#333333"
          fill-opacity="1"
          d="M0,160L48,181.3C96,203,192,245,288,256C384,267,480,245,576,240C672,235,768,245,864,245.3C960,245,1056,235,1152,229.3C1248,224,1344,224,1392,224L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        ></path>
      </svg>
      <div className="container mx-auto">
        <div className="title dark">
          <h1>Tokoonomics</h1>
          <img src="/images/claw_title.png" alt="Claw" className="claw-title" />
        </div>

        <div className="tokenomics-info">
          <motion.div
            className="info-card"
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true, amount: 1 }}
          >
            <svg
              className="icon"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15.59 14.37a6 6 0 0 1-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 0 0 6.16-12.12A14.98 14.98 0 0 0 9.631 8.41m5.96 5.96a14.926 14.926 0 0 1-5.841 2.58m-.119-8.54a6 6 0 0 0-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 0 0-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 0 1-2.448-2.448 14.9 14.9 0 0 1 .06-.312m-2.24 2.39a4.493 4.493 0 0 0-1.757 4.306 4.493 4.493 0 0 0 4.306-1.758M16.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
              />
            </svg>
            <p>Fair Launch</p>
          </motion.div>

          <motion.div
            className="info-card"
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true, amount: 1 }}
          >
            <LockClosedIcon className="icon" />
            <p>No Pre-Allocation</p>
          </motion.div>

          <motion.div
            className="info-card"
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            viewport={{ once: true, amount: 1 }}
          >
            <BanIcon className="icon" />
            <p>No Presale</p>
          </motion.div>

          <motion.div
            className="info-card"
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
            viewport={{ once: true, amount: 1 }}
          >
            <CurrencyDollarIcon className="icon" />
            <p>No Taxes</p>
          </motion.div>
        </div>

        <div className="flex justify-between infos">
          <motion.div
            className="supply-info"
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            viewport={{ once: true, amount: 1 }}
          >
            <h3>Total Supply</h3>
            <p className="supply-amount">20,000,000,000</p>
          </motion.div>

          <motion.div
            className="supply-info"
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            viewport={{ once: true, amount: 1 }}
          >
            <h3>Tokens per mint</h3>
            <p className="supply-amount">40,000</p>
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default Tokenomics;
